import { render, staticRenderFns } from "./OfferTemplate.vue?vue&type=template&id=140e3155&scoped=true&"
import script from "./OfferTemplate.vue?vue&type=script&lang=js&"
export * from "./OfferTemplate.vue?vue&type=script&lang=js&"
import style0 from "./OfferTemplate.vue?vue&type=style&index=0&id=140e3155&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140e3155",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VCard,VDivider})
